import { Reveal, Eyebrow } from "./Reveal";
import { skills } from "../../data/resume";

export const Skills = () => {
  return (
    <section
      id="skills"
      data-testid="skills-section"
      className="border-t border-hair bg-ink text-paper"
    >
      <div className="mx-auto max-w-[1400px] px-6 sm:px-12 lg:px-20 py-24 lg:py-36">
        <Reveal>
          <Eyebrow className="text-inkmuted">(Skills)</Eyebrow>
          <h2 className="mt-6 font-serif font-normal text-4xl sm:text-5xl lg:text-6xl text-paper">
            The toolkit
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {skills.map((cat, i) => (
            <Reveal key={i} delay={0.08 * i}>
              <div className="h-full bg-ink p-8 lg:p-10">
                <div className="flex items-baseline gap-3">
                  <span className="font-mono text-xs text-rust">0{i + 1}</span>
                  <h3 className="font-serif text-xl sm:text-2xl text-paper">
                    {cat.name}
                  </h3>
                </div>
                <ul className="mt-6 flex flex-wrap gap-2">
                  {cat.items.map((s) => (
                    <li
                      key={s}
                      className="rounded-full border border-white/20 px-3 py-1.5 font-sans text-xs sm:text-sm text-paper/80 transition-colors duration-300 hover:border-rust hover:text-rust"
                    >
                      {s}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
